import React from 'react';
import {observer} from 'mobx-react';

import {
    ADDRESS_LINK,
    CALL_NOW_BTN_SECONDARY,
    DIRECTORY_SEARCH_RESULT_CARD_LINK,
    PROFILE_CARD,
    PROFILE_CONTACT_TYPE,
    SEE_OUT_OF_POCKET_COSTS,
} from 'core/constants.js';
import PracticeListCardV2 from './PracticeListCardV2';
import {PracticeStoreContextV2} from 'core/stores/RootStore.js';
import {CardV2, NotificationV2} from '@HealthShareAU/hs-component-library';
import {partitionArray} from 'utils/arrays.js';
import {hexToRgba} from 'utils/colors.js';
import {toJS} from 'mobx';

@observer
class PracticeListV2 extends React.Component {
    static contextType = PracticeStoreContextV2;

    constructor(props) {
        super(props);
        this.state = {
            callNowModalOpen: false,
            selectedItem: {},
        };
    }

    getFees() {
        const {loadFees} = this.context;
        if (loadFees) {
            return {
                feesUrl: `#fees`,
                gaObjectType: PROFILE_CARD,
                gaSelector: SEE_OUT_OF_POCKET_COSTS,
            };
        }
        return null;
    }

    getSectionFragments(practiceLocations, healthFund, isSkin) {
        const shouldGroupLocationsByHFR =
            this.context?.ancillary?.behaviour ===
                'KEEP_WITH_HFR_DATA_ATTACHED' && !!healthFund?.name;

        const disableLinks =
            !!isSkin &&
            !this.context.practice.isSpecialist &&
            !this.context.isPracticeLocationAncillaryEnabled;

        if (shouldGroupLocationsByHFR) {
            const participatingHealthFundId = this.context.ancillary
                ?.gapSchemeHealthFundId;

            const [
                participating,
                nonParticipating,
            ] = partitionArray(practiceLocations, (pl) =>
                pl?.healthFundRelationship?.some(
                    (hfr) =>
                        !!participatingHealthFundId &&
                        hfr.healthFundId === participatingHealthFundId,
                ),
            );

            return (
                <>
                    {!!participating.length && (
                        <NotificationV2
                            customClass="phi-banner-override"
                            htmlText={`<p>This practitioner may partner with <strong>${healthFund.name}</strong> at the following locations</p>`}
                            colorTheme={{
                                color: !!healthFund.colorBrand
                                    ? `#${healthFund.colorBrand}`
                                    : '',
                                backgroundColor: !!healthFund.colorBrand
                                    ? hexToRgba(healthFund.colorBrand, 0.1)
                                    : '',
                                padding: '16px',
                            }}
                            displayImage={<img src={healthFund.avatar} />}
                        />
                    )}
                    {!!participating.length && (
                        <ul>
                            {participating.map((pl) => (
                                <PracticeListCardV2
                                    key={pl.id}
                                    practice={pl}
                                    disabled={disableLinks}
                                />
                            ))}
                        </ul>
                    )}
                    {!!nonParticipating.length && (
                        <NotificationV2
                            htmlText={`<p>This practitioner may not partner with <strong>${healthFund.name}</strong> at the following locations</p>`}
                            type="error"
                        />
                    )}
                    {!!nonParticipating.length && (
                        <ul>
                            {nonParticipating.map((pl) => (
                                <PracticeListCardV2
                                    key={pl.id}
                                    practice={pl}
                                    disabled={disableLinks}
                                />
                            ))}
                        </ul>
                    )}
                </>
            );
        }

        return [
            <ul>
                {practiceLocations.map((pl) => (
                    <PracticeListCardV2
                        key={pl.id}
                        practice={pl}
                        disabled={disableLinks}
                    />
                ))}
            </ul>,
        ];
    }

    render() {
        const {
            practice,
            renderCallNowModal,
            rootStore: {
                healthFundStore: {healthFund},
                paramStore: {hasSkin},
            },
        } = this.context;

        return (
            <>
                {this.getSectionFragments(
                    practice.locations,
                    healthFund,
                    hasSkin,
                )}
                {renderCallNowModal()}
            </>
        );
    }
}

export default PracticeListV2;
